import React, { forwardRef } from 'react';

import './CarouselTrack.css';

type CarouselTrackProps = {
    children: React.ReactNode;
    className?: string;
};

export const CarouselTrack = forwardRef<HTMLDivElement, CarouselTrackProps>(function CarouselTrack(
    { children, className },
    ref,
) {
    const classes = `carousel-track${className ? ` ${className}` : ''}`;
    return (
        <div ref={ref} className={classes}>
            {children}
        </div>
    );
});
